var render, staticRenderFns
import script from "./terminal_integral.vue?vue&type=script&lang=js"
export * from "./terminal_integral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44862cea')) {
      api.createRecord('44862cea', component.options)
    } else {
      api.reload('44862cea', component.options)
    }
    
  }
}
component.options.__file = "found/views/mall/views/integral_mall_management/terminal_integral/terminal_integral.vue"
export default component.exports